<template>
  <div>
    <vue-table :table-data="tableData" ref="tableRef">
      <template slot="operateBar">
        <el-button-group>
          <el-button v-if="checkApi('addServerLicense')" size="small" type="primary" @click="add">添加授权码</el-button>
        </el-button-group>
      </template>
      <template v-if="hasApi(['reviseServerLicense','deleteServerLicense'])" slot="actionBar">
        <el-table-column align="center" label="操作栏" :resizable="false" width="120">
          <template slot-scope="{row}">
            <el-button v-if="checkApi('reviseServerLicense')" type="text" @click="revise(row)">修改</el-button>
            <el-button v-if="checkApi('deleteServerLicense')" type="text" class="danger" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </vue-table>
    <server-operate v-if="serverOperate.visible" :dialog-data="serverOperate" @table-reload="getTableList"/>
  </div>
</template>

<script>
  import ServerOperate from "./dialog/ServerOperate"
  import {licenseType, serverStatus, serverType, serverFrom} from "@utils/formatList"
  export default {
    name: "serverManage",
    components: {ServerOperate},
    data() {
      return {
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "授权类型", property: "type", format: licenseType, width: 80},
            {label: "UUID", property: "uuid", width: 300},
            {label: "状态", property: "status", format: serverStatus, width: 70},
            {label: "可使用天数", property: "use_days", width: 100},
            {label: "激活时间", property: "active_at"},
            {label: "到期时间", property: "expire_at"},
            {label: "主机编号", property: "host_id", width: 300},
            {label: "主机名", property: "hostname"},
            {label: "创建来源", property: "from", format: serverFrom, width: 100},
          ],
          api: "getServerLicense",
          hasExpand: true,
          expandLabelWidth: 130,
          expandColumn: [
            {label: "授权类型", property: "type", format: licenseType},
            {label: "UUID", property: "uuid"},
            {label: "状态", property: "status", format: serverStatus},
            {label: "可使用天数", property: "use_days"},
            {label: "类型", property: "type", format: serverType},
            {label: "激活时间", property: "active_at"},
            {label: "到期时间", property: "expire_at"},
            {label: "主机编号", property: "host_id"},
            {label: "主机名", property: "hostname"},
            {label: "激活IP", property: "active_ip"},
            {label: "BIOS时间", property: "bios_date"},
            {label: "BIOS厂商", property: "bios_vendor"},
            {label: "BIOS版本", property: "bios_version"},
            {label: "内核核心", property: "kernel_arch"},
            {label: "内核版本", property: "kernel_version"},
            {label: "操作系统", property: "os"},
            {label: "平台", property: "platform"},
            {label: "平台簇", property: "platform_family"},
            {label: "平台版本", property: "platform_version"},
            {label: "备注", property: "remark"},
            {label: "创建来源", property: "from", format: serverFrom},
          ]
        },
        countList: [{name: "总记录", count: 0}],
        serverOperate: {visible: false, width: 450, title: "", row: null},
      }
    },
    methods: {
      add() {
        this.serverOperate.visible = true;
        this.serverOperate.title = "添加授权码";
        this.serverOperate.row = null;
      },
      revise(row) {
        this.serverOperate.visible = true;
        this.serverOperate.title = "修改授权码";
        const nv = {...row};
        nv.status = +nv.status;
        this.serverOperate.row = nv;
      },
      remove(row) {
        this.openConfirm("删除该授权码", async () => {
          let nv = {server_license_id: row.id};
          let res = await this.$Http.deleteServerLicense(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.getTableList();
          }
        });
      },
      getTableList() {
        this.$refs["tableRef"].refresh();
      },
    },
  }
</script>

<style scoped>

</style>
